import { type FC, type ReactNode } from "react";

import { type ApolloError } from "@apollo/client";
import styled from "@emotion/styled";

import { ApiErrorNotice } from "../../insights/components/chart/ApiErrorNotice";
import { SearchableCard } from "../components/SearchableCard";

const DynamicSearchableCard = styled(SearchableCard)`
    margin: 6px 0;

    .sds-card-body {
        overflow: hidden;
        height: 68vh;
        margin: 0;
    }
`;

interface SearchableCardWithUpsellBannerProps {
    searchValue: string;
    onSearch: (text: string) => void;
    error?: ApolloError;
    isLoading: boolean;
    searchPlaceholder: string;
    padBody: boolean;
    loadingTooltip?: string;
    children: ReactNode;
}

const SearchableCardWithUpsellBanner: FC<SearchableCardWithUpsellBannerProps> = ({
    searchPlaceholder,
    searchValue,
    onSearch,
    isLoading,
    children,
    loadingTooltip,
    error,
}) => {
    return (
        <ApiErrorNotice error={error}>
            <DynamicSearchableCard
                searchPlaceholder={searchPlaceholder}
                padBody={false}
                searchValue={searchValue}
                onSearch={onSearch}
                isLoading={isLoading}
                tooltip={loadingTooltip}
            >
                {children}
            </DynamicSearchableCard>
        </ApiErrorNotice>
    );
};

export { SearchableCardWithUpsellBanner };
